export const hideElements = () => {
    const newsText = document.querySelector(".news-content-inner__toggle");
    const buttons = document.querySelectorAll(".openButton");
    const fadeNews = document.querySelector(".fadeNews");

    if (newsText) {
        newsText.style.display = "none";
    }

    if (fadeNews) {
        fadeNews.style.display = "none";
    }

    buttons.forEach((button) => {
        button.style.display = "none";
    });
};
